import { render, staticRenderFns } from "./house.vue?vue&type=template&id=5494dce4&scoped=true"
import script from "./house.vue?vue&type=script&lang=js"
export * from "./house.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5494dce4",
  null
  
)

export default component.exports